import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { SetOrganisationGeneral } from "./OrganisationGeneralActions";
import { TextField, Grid, Chip } from "@material-ui/core";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     "& > *": {
//       margin: theme.spacing(1),
//       //   width: "70%",
//     },
//   },
//   container: {
//     display: "flex",
//     flexWrap: "wrap",
//   },
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     width: 200,
//   },
// }));

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function General(props) {
  const dispatch = useDispatch();

  const {
    record_owner_id,
    has_admin_access,
    do_not_contact,
    do_not_mailshot,
    total_number_of_assignment,
    // client_panel_areas,
    list_of_assignment_id,
    number_of_assignment_id,
    client_panel_areas,
  } = useSelector((state) => state.organisationGeneralReducer.data);
  const reducerData = useSelector(
    (state) => state.organisationGeneralReducer.data
  );

  const { record_owners, number_of_assignments, list_of_assignments } =
    useSelector((state) => state.commonReducer.organisationDropdowns);

  const clientPanelAreaSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.client_panel_areas
  );

  const errors = useSelector(
    (state) => state.organisationGeneralReducer.errors
  );

  const handleInputChange = (value, index) => {
    props.setSomeChangeDetected(true)
    const updatedForm = formInput;
    updatedForm[index]["value"] = value;
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      if (item.value) {
        formData[item.name] = item.value;
        dispatch(SetOrganisationGeneral(formData));
      }
    });
  };

  console.log("reducerData", reducerData);

  const formArray = [
    {
      componentType: "SelectSpecific",
      label: "Record owner",
      name: "record_owner_id",
      id: "record_owner_id",
      placeholder: "Record owner",
      selectOptions: record_owners,
      // selectOptions: [{id: 0, value: 'KB', name: 'KB'},{id: 1, value: 'SJ', name: 'SJ'},{id: 2, value: 'LD', name: 'LD'},{id: 3, value: 'CP', name:'CP'},{id: 4, value: 'AS', name: 'AS'},{id: 5, value: 'SC', name: 'SC'}],
      value: record_owner_id,
      handleChange: handleInputChange,
      dropDown: "RecordOwner",
      field_name: "record_owner",
    },
    {
      componentType: "input",
      label: "Admin access",
      multiline: true,
      name: "has_admin_access",
      placeholder: "Select admin access",
      // selectOptions: [{ id: '0', value: 'True' }, { id: '1', value: 'False' }],
      value: has_admin_access,
      apiVariable: "has_admin_access_values",
      handleChange: handleInputChange,
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Do Not Contact",
    //   name: "do_not_contact",
    //   placeholder: "Do not contact",
    //   handleChange: handleInputChange,
    //   value: do_not_contact
    // },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Do Not Mailshot",
    //   name: "do_not_mailshot",
    //   placeholder: "Do not mailshot",
    //   handleChange: handleInputChange,
    //   value: do_not_mailshot
    // },

    // {
    //   componentType: "select",
    //   label: "Number of Assignment",
    //   name: "number_of_assignment_id",
    //   value: number_of_assignment_id ,
    //   placeholder: "Select number of assignment",
    //   selectOptions: number_of_assignments,
    //   handleChange: handleInputChange,
    //   dropDown: "NumberOfAssignment",
    //   field_name: "number_of_assignment",
    // },
    {
      componentType: "input",
      type: "text",
      label: "Total no of assignments",
      name: "total_number_of_assignment",
      placeholder: "Total no of assignments",
      value: total_number_of_assignment || 0,
      disabled: true,
    },
    {
      componentType: "SelectSpecific",
      label: "Information",
      name: "list_of_assignment_id",
      id: "list_of_assignment_id",
      placeholder: "Information",
      selectOptions: list_of_assignments,
      value: list_of_assignment_id,
      handleChange: handleInputChange,
      dropDown: "ListOfAssignment",
      field_name: "value",
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Total No of Assignments",
    //   name: "total_no_of_assignments",
    //   placeholder: "Total no of assignments",
    //   handleChange: handleInputChange,
    //   value: total_no_of_assignments
    // },

    {
      componentType: "SelectSpecific",
      label: "Number of assignments",
      name: "number_of_assignment_id",
      id: "number_of_assignment_id",
      value: number_of_assignment_id,
      placeholder: "Select number of assignments",
      selectOptions: number_of_assignments,
      handleChange: handleInputChange,
      dropDown: "NumberOfAssignment",
      field_name: "number_of_assignment",
    },
    {
      componentType: "rederComponent",
      component: (
        <CustomClientPanelArea
          label="Client panel area"
          data={client_panel_areas}
        />
      ),
    },
  ];

  const [formInput, setFormInput] = useState(formArray);
  useEffect(() => {
    setFormInput(formArray);
  }, [
    errors,
    number_of_assignments,
    record_owners,
    record_owner_id,
    number_of_assignment_id,
    list_of_assignment_id,
    list_of_assignments,
  ]);
  return (
    <FormGenerator
      children={formInput}
      handleNext={props.handleNext}
      nextIndex={7}
      setId={props.setId}
      moduleName="organization"
    />

  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red",
  },
  disabled: {
    background: "#f5f2f2",
  },

  textInput: {
    "& input::placeholder": {
      color: "#808080",
      opacity: 1,
    },
  },
}));
const CustomClientPanelArea = (props) => {
  const { data, label } = props;
  const classes = useStyles();
  console.log("data", data);
  let newValue = {};
  data?.length &&
    data.forEach((item) => {
      if (!item.role) {
        if (newValue["Other"]?.length) {
          newValue["Other"].push(item);
        } else {
          newValue["Other"] = [item];
        }
      } else {
        if (newValue[item.role]?.length) {
          newValue[item.role].push(item);
        } else {
          newValue[item.role] = [item];
        }
      }
    });
  return (
    <Grid container>
      <Grid item xs={12} md={4}>
        {label}
      </Grid>
      <Grid xs={12} md={7}>
        <Grid style={{ marginBottom: 20, opacity: 0.8 }}>
          <TextField
            variant="outlined"
            multiline
            disabled
            rows={4}
            defaultValue={data?.length ? "" : label}
            InputProps={{
              startAdornment: Object.keys(newValue)?.map((keyName) => (
                <>
                  <Grid container>
                    <Grid item xs={3}>
                      <span
                        style={{
                          marginTop: "7px",
                          display: "inline-block",
                        }}
                      >
                        {keyName}
                      </span>
                    </Grid>
                    <Grid item xs={9} style={{ paddingBottom: "10px" }}>
                      {newValue[keyName].map((item, index) => (
                        <Chip
                          key={index}
                          // label={`${item.id} - ${item.value}`}
                          label={
                            item?.role
                              ? item.name + " - " + item.role
                              : item.name
                          }
                          style={{ margin: "3px" }}
                        />
                      ))}
                    </Grid>
                  </Grid>
                </>
              )),
              classes: {
                disabled: classes.disabled,
              },
              style: { alignItems: "start", flexWrap: "wrap" },
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
